import { Model } from "../../classes/mvc/Model";

export class ModelBasket extends Model {
    
}